import React, { useState, useEffect } from 'react';
import { SunIcon, MoonIcon } from '@heroicons/react/24/outline';
import { getTheme, toggleTheme } from '../utils/theme';

export const ThemeToggle: React.FC = () => {
  const [theme, setThemeState] = useState<'light' | 'dark'>(() => getTheme());

  useEffect(() => {
    // Atualizar estado quando tema mudar
    const handleThemeChange = () => {
      const currentTheme = getTheme();
      setThemeState(currentTheme);
    };

    // Listener para evento customizado de mudança de tema
    window.addEventListener('themechange', handleThemeChange);
    
    // Listener para mudanças no localStorage (outras abas)
    window.addEventListener('storage', handleThemeChange);
    
    // Polling para detectar mudanças (localStorage não dispara evento na mesma aba)
    const interval = setInterval(() => {
      const currentTheme = getTheme();
      if (currentTheme !== theme) {
        setThemeState(currentTheme);
      }
    }, 100);

    return () => {
      window.removeEventListener('themechange', handleThemeChange);
      window.removeEventListener('storage', handleThemeChange);
      clearInterval(interval);
    };
  }, [theme]);

  const getIcon = () => {
    return theme === 'light' ? <SunIcon className="h-5 w-5" /> : <MoonIcon className="h-5 w-5" />;
  };

  const getTooltip = () => {
    return theme === 'light' 
      ? 'Tema claro (clique para escuro)' 
      : 'Tema escuro (clique para claro)';
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const newTheme = toggleTheme();
    setThemeState(newTheme);
  };

  return (
    <button
      onClick={handleClick}
      className="p-2 rounded-lg transition-colors duration-200"
      style={{
        color: 'var(--text-muted)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = 'var(--text-primary)';
        e.currentTarget.style.backgroundColor = 'var(--bg-tertiary)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.color = 'var(--text-muted)';
        e.currentTarget.style.backgroundColor = 'transparent';
      }}
      aria-label={getTooltip()}
      title={getTooltip()}
      type="button"
    >
      {getIcon()}
    </button>
  );
};
